import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "NEMA_6-50P",
  "use": "NEMA_6-50P-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"NEMA_6-50P\"><path d=\"M20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5zm0 1.5C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zM17.5 5.5V9a2.5 2.5 0 105 0V5.5h-5zM16 4h8v5a4 4 0 11-8 0V4zM7.5 18.5v7h2v-7h-2zM6 17h5v10H6V17zm23.5-.5v10h2v-10h-2zM28 15h5v13h-5V15z\" fill=\"#000\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol